import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Typography,
  Stack,
  Box,
  Button,
  InputAdornment,
  TextField,
  Select,
  FormControl,
  MenuItem,
  Divider,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useQuery } from "@apollo/client";
// icon
import { LuSearch } from "react-icons/lu";
import SchoolIcon from "@mui/icons-material/School";

// src
import "../../Style/pageStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import EmptyData from "../../Components/Include/EmptyData";
import LoadingPage from "../../Components/Include/LoadingPage";
import { GET_CLASS_PAGINATION } from "../../Schema/Class";
import {
  SelectSchool,
  SelectGroup,
  SelectTeacher,
  SelectAcademicYear,
  SelectLevel
} from "../../Function/DynamicSelect";
import { GET_ACTIVE_ACADEMIC_YEAR } from "../../Schema/AcademicYear"

export default function Attendance() {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  let userLogin = JSON.parse(window.localStorage.getItem("logIn"));

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [academicYearVal, setAcademicYearVal] = useState({ id: "", title: "" });
  const [schoolVal, setSchoolVal] = useState({ id: "", title: "" });
  const [groupVal, setGroupVal] = useState({ id: "", title: "" });
  const [teacherVal, setTeacherVal] = useState({ id: "", title: "" });
  const [levelVal, setLevelVal] = useState({ id: "", title: "" });

  const { refetch: refetchAcademic } = useQuery(GET_ACTIVE_ACADEMIC_YEAR, {
    onCompleted: ({ getActiveAcademicYear }) => {
      setAcademicYearVal({
        id: getActiveAcademicYear?._id,
        title: getActiveAcademicYear?.academic_year
      });
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    if (userLogin?.role === "Teacher") {
      setTeacherVal({ id: userLogin?._id, title: language === "en" ? userLogin?.latin_name : userLogin?.last_name + " " + userLogin?.first_name })
    }
  }, [language])

  const [tableData, setTableData] = useState();
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(12);

  const { refetch, data } = useQuery(GET_CLASS_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      pagination: true,
      keyword: keyword,
      academicYearId: academicYearVal?.id,
      schoolId: schoolVal?.id,
      groupId: groupVal?.id,
      teacherId: teacherVal?.id,
      levelId: levelVal?.id,
    },
    // onCompleted: ({ getClassWithPagination }) => {
    //   setTableData(getClassWithPagination?.data);
    //   setPaginationData(getClassWithPagination?.paginator);
    //   setLoading(false);
    // },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    if (data?.getClassWithPagination) {
      setTableData(data?.getClassWithPagination?.data);
      setPaginationData(data?.getClassWithPagination?.paginator);
      setLoading(false);
    }
  }, [data])

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  useEffect(() => {
    refetch();
  }, [page, limit, keyword, academicYearVal?.id, schoolVal?.id, groupVal?.id, teacherVal?.id, levelVal?.id]);

  useEffect(() => { refetchAcademic() }, [])



  return (
    <div className="page-container">
      <Stack direction="column">
        <Stack direction="row" spacing={2} className="page-header">
          <Stack direction="column" justifyContent="center">
            <Box className="slash" />
          </Stack>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems={`center`}
          >
            <Typography
              className={language === "kh" ? "page-title-kh" : "page-title"}
            >
              {t(`page-attendance`)}
            </Typography>
          </Stack>
        </Stack>
        <Stack mt={2}>
          <Divider />
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 2 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`academic_year`)}
            </Typography>
            <SelectAcademicYear
              selectedVal={academicYearVal}
              setSelectedVal={setAcademicYearVal}
              className="search-field"
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 2 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`school`)}
            </Typography>
            <SelectSchool
              selectedVal={schoolVal}
              setSelectedVal={setSchoolVal}
              className="search-field"
              disabled={userLogin?.role === "Teacher" ? true : false}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 2 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`grade_level`)}
            </Typography>
            <SelectLevel
              selectedVal={levelVal}
              setSelectedVal={setLevelVal}
              className="search-field"
              disabled={userLogin?.role === "Teacher" ? true : false}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 2 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`group`)}
            </Typography>
            <SelectGroup
              selectedVal={groupVal}
              setSelectedVal={setGroupVal}
              className="search-field"
              disabled={userLogin?.role === "Teacher" ? true : false}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 2 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`teacher`)}
            </Typography>
            <SelectTeacher
              selectedVal={teacherVal}
              setSelectedVal={setTeacherVal}
              className="search-field"
              disabled={userLogin?.role === "Teacher" ? true : false}
            />
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ marginTop: "25px" }}>
        <Grid container spacing={2}>
          {loading ? (
            <Grid size={{ xs: 12 }}>
              <LoadingPage />
            </Grid>
          ) : (
            <>
              {tableData?.length === 0 ? (
                <Grid size={{ xs: 12 }}>
                  <EmptyData />
                </Grid>
              ) : (
                <>
                  {tableData?.map((item, index) => {
                    return (
                      <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 3 }} key={index}>
                        <Stack
                          direction="column"
                          spacing={2}
                          className="card-enrollment-container"
                          sx={{
                            ":hover": {
                              backgroundColor: "rgb(239, 246, 253)",
                              cursor: "pointer",
                            },
                          }}
                          onClick={() =>
                            navigate(
                              `/attendance/attendance-check?id=${item?._id
                              }&class=${item?.level_id?.level_name +
                              item?.group_id?.group_name
                              }`
                            )
                          }
                        >
                          <Stack direction={`row`}>
                            <Stack
                              direction={`column`}
                              justifyContent={`center`}
                              alignItems={"center"}
                              className="icons-bg"
                            >
                              <SchoolIcon className="icons" />
                            </Stack>
                          </Stack>

                          <Stack direction="column">
                            <Typography className="group-title">
                              {item?.level_id?.level_name +
                                " " +
                                item?.group_id?.group_name}
                            </Typography>
                            <Typography className="school-title">
                              {language === "kh"
                                ? item?.school_id?.school_name
                                : item?.school_id?.school_name_en}
                            </Typography>
                          </Stack>
                          <Stack
                            direction="column"
                            className="detail-container"
                            spacing={0.5}
                          >
                            <Stack direction="row">
                              <Typography
                                className={language === "en" ? "txt" : "txt-kh"}
                                width={`40%`}
                              >
                                {t(`academic_year`)}
                              </Typography>
                              <Typography
                                className={language === "en" ? "txt" : "txt-kh"}
                                width={`10%`}
                              >
                                :
                              </Typography>
                              <Typography
                                className={language === "en" ? "txt" : "txt-kh"}
                                idth={`50%`}
                              >
                                {item?.academic_year_id?.academic_year}
                              </Typography>
                            </Stack>
                            <Stack direction="row">
                              <Typography
                                className={language === "en" ? "txt" : "txt-kh"}
                                width={`40%`}
                              >
                                {t(`teacher`)}
                              </Typography>
                              <Typography
                                className={language === "en" ? "txt" : "txt-kh"}
                                width={`10%`}
                              >
                                :
                              </Typography>
                              <Typography
                                className={language === "en" ? "txt" : "txt-kh"}
                                idth={`50%`}
                              >
                                {language === "en"
                                  ? item?.teacher_id?.latin_name
                                  : item?.teacher_id?.last_name +
                                  " " +
                                  item?.teacher_id?.first_name}
                              </Typography>
                            </Stack>
                            {/* <Stack direction="row">
                              <Typography
                                className={language === "en" ? "txt" : "txt-kh"}
                                width={`40%`}
                              >
                                {t("total-student")}
                              </Typography>
                              <Typography
                                className={language === "en" ? "txt" : "txt-kh"}
                                width={`10%`}
                              >
                                :
                              </Typography>
                              <Typography
                                className={language === "en" ? "txt" : "txt-kh"}
                                width={`50%`}
                              >
                                {item?.totalStu}
                              </Typography>
                            </Stack> */}
                          </Stack>
                        </Stack>
                      </Grid>
                    );
                  })}
                </>
              )}
            </>
          )}
        </Grid>
      </Box>
    </div>
  );
}
